import { Injectable } from "@angular/core";
import { HandleError, HttpErrorHandler, HttpUtility } from "@core/http";
import { Observable, catchError } from "rxjs";
import { WoundCareConnectComment, WoundCareConnectComments } from "@core/model/wcc-comment.model";
import { ShellService } from "@mynexus/mfe-core";
import { ProductNames } from "@mynexus/mynexus-ui-lib";

@Injectable({
  providedIn: 'root'
})
export class WoundCareConnectCommunicationService {
  public handleError: HandleError;
  private readonly apiBaseUrl: string;

  constructor(
    private httpUtility: HttpUtility,
    private httpErrorHandler: HttpErrorHandler,
    shellService: ShellService
  ) {
    this.handleError = this.httpErrorHandler.createHandleError('WoundCareConnectCommunicationService');
    this.apiBaseUrl = shellService.getBaseUrlFor(ProductNames.HomeHealth);
  }

  public getAdmissionComments(tenantId: string | undefined, admissionId: string, offset: number, max: number = 5): Observable<WoundCareConnectComments> {
    const url = `${this.apiBaseUrl}/tenants/${tenantId}/WCCComment/${admissionId}?offset=${offset}&max=${max}`;

    return this.httpUtility
      .get<WoundCareConnectComments>(url)
      .pipe(
        catchError(this.handleError('getWoundCareAdmissions', {} as WoundCareConnectComments)));
  }

  public addComment(tenantId: string, itemToAdd: WoundCareConnectComment): Observable<WoundCareConnectComment> {
    const url = `${this.apiBaseUrl}/tenants/${tenantId}/WCCComment/${itemToAdd.admissionId}/create`;

    return this.httpUtility
      .post<WoundCareConnectComment>(url, itemToAdd)
      .pipe(
        catchError(this.handleError('getWoundCareAdmissions', {} as WoundCareConnectComment)));
  }

  public updateComment(tenantId: string, itemWithUpdates: WoundCareConnectComment): Observable<boolean> {
    const url = `${this.apiBaseUrl}/tenants/${tenantId}/WCCComment/${itemWithUpdates.communicationCommentId}`;

    return this.httpUtility
      .post<boolean>(url, itemWithUpdates)
      .pipe(
        catchError(this.handleError('updateComment', false as boolean)));
  }

  public deleteComment(tenantId: string, itemToDelete: WoundCareConnectComment): Observable<boolean> {
    const url = `${this.apiBaseUrl}/tenants/${tenantId}/WCCComment/${itemToDelete.communicationCommentId}`;

    return this.httpUtility
      .delete<boolean>(url, itemToDelete)
      .pipe(
        catchError(this.handleError('delete', false as boolean)));
  }

  public readComments(tenantId: string, admissionId: string, commentsIds: string[]): Observable<WoundCareConnectComments> {
    const url = `${this.apiBaseUrl}/tenants/${tenantId}/WCCComment/${admissionId}/read`;

    return this.httpUtility
      .post<WoundCareConnectComments>(url, commentsIds)
      .pipe(
        catchError(this.handleError('readComments', {} as WoundCareConnectComments)));
  }
}